/* Project Moss — Sticky bundle bar scroll trigger */
(function () {
  'use strict';

  function initBar(bar) {
    const threshold = parseInt(bar.dataset.scrollThreshold, 10) || 700;
    let visible = false;

    function update() {
      const shouldShow = window.scrollY > threshold;
      if (shouldShow === visible) return;
      visible = shouldShow;
      bar.classList.toggle('is-visible', visible);
    }

    window.addEventListener('scroll', update, { passive: true });
    update();
  }

  function initAll() {
    document.querySelectorAll('.moss-stickybar').forEach(initBar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
